module.exports = __webpack_public_path__ + "baa4ddd64d0d3c28d633429c0b5fe4a2.pdf";